/* eslint-disable no-console */
/**
 * package.json devDependencies 需添加 @vue/cli-plugin-pwa
 */
import {register} from 'register-service-worker'
if (process.env.NODE_ENV === 'production') {

    register(`${process.env.VUE_APP_DOMAIN_BASE}/service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered() {
            console.log('Service worker has been registered.')
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
            vant.Toast.loading({
                duration: 8000, // 持续展示 toast
                forbidClick: true,
                message: '更新中...',
            });
        },
        updated() {
            console.log('New content is available; please refresh.')
            vant.Toast.loading({
                duration: 8000, // 持续展示 toast
                forbidClick: true,
                message: '更新中...',
            });
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        },
        offline() {
            console.log(
                'No internet connection found. App is running in offline mode.'
            )
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        },
    })
}
